.wrapper {
  min-height: 50vh;
  display: grid;
  place-content: center;
  gap: 0.75rem;
  text-align: center;
}

.code {
  margin: 0;
  color: var(--color-primary);
  font-size: 4rem;
  font-weight: 800;
  line-height: 1;
}

.link {
  color: var(--color-primary);
  font-weight: 600;
}
